/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Success_Updatecategory1Inputs */

const en_cases_settings_success_updatecategory1 = /** @type {(inputs: Cases_Settings_Success_Updatecategory1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category updated`)
};

/**
* | output |
* | --- |
* | "Category updated" |
*
* @param {Cases_Settings_Success_Updatecategory1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_success_updatecategory1 = /** @type {((inputs?: Cases_Settings_Success_Updatecategory1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Success_Updatecategory1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_success_updatecategory1(inputs)
});
export { cases_settings_success_updatecategory1 as "cases_settings_success_updateCategory" }